// Generated by purs version 0.14.5
"use strict";
var Unsafe_Coerce = require("../Unsafe.Coerce/index.js");
var coerce = function (dictCoercible) {
    return Unsafe_Coerce.unsafeCoerce;
};
module.exports = {
    coerce: coerce
};
